// use hubspot.bender to access all dep package assets (not just documents-lib)
// @ts-expect-error No types
import bender from 'hubspot.bender';
import { Component } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import I18n from 'I18n';
import PDFKeyControls from './PDFKeyControls';
import PDFPage from './PDFPage';
import PDFControls from './PDFControls';
import PDFLoading from './PDFLoading';
import PDFError from './PDFError';
import { connect } from 'react-redux';
import * as PDFActions from '../../actions/PDFActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PDFViewer extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hovered: false,
      progress: null,
      pdf: null,
      error: null,
      PDFJS: null,
      PDFJSError: null
    };
    this.retry = () => {
      window.location.reload();
    };
    this.loadPDFJS = () => {
      return new Promise((resolve, reject) => {
        // @ts-expect-error No types
        import( /* webpackChunkName: "pdf-js" */'../../lib/pdf-js').then(({
          PDFJS
        }) => this.setState({
          PDFJS,
          PDFJSError: null
        }, () => {
          resolve(undefined);
        })).catch(error => this.setState({
          PDFJSError: error
        }, () => {
          reject(error);
        }));
      });
    };
    this.loadFile = () => {
      const {
        file
      } = this.props;
      const {
        PDFJS
      } = this.state;
      const documentTask = PDFJS.getDocument({
        url: file,
        cMapUrl: `${bender.staticDomainPrefix}${bender.depPathPrefixes['pdf-js']}/cmaps/`,
        cMapPacked: true,
        isEvalSupported: false
      });
      documentTask.onProgress = ({
        loaded,
        total
      }) => {
        this.setState({
          progress: loaded / total * 100
        });
      };
      documentTask.promise.then(pdf => {
        this.setState({
          pdf,
          error: null,
          progress: null
        });
      }).catch(error => {
        this.setState({
          error
        });
      });
    };
    this.handleMouseEnter = () => {
      this.setState({
        hovered: true
      });
    };
    this.handleMouseLeave = () => {
      this.setState({
        hovered: false
      });
    };
    this.renderProgress = () => {
      const {
        pageIndex,
        imagePlaceholders
      } = this.props;
      const {
        progress
      } = this.state;
      if (progress === null) {
        return /*#__PURE__*/_jsx(PDFLoading, {
          pageIndex: pageIndex,
          imagePlaceholders: imagePlaceholders,
          value: 0
        });
      }
      return /*#__PURE__*/_jsx(PDFLoading, {
        pageIndex: pageIndex,
        imagePlaceholders: imagePlaceholders,
        value: progress
      });
    };
    this.renderPDFKeyControls = () => {
      const {
        pageIndex,
        zoom,
        onPage,
        onChangePageCHIRP
      } = this.props;
      const {
        pdf
      } = this.state;
      return /*#__PURE__*/_jsx(PDFKeyControls, {
        onPage: onPage,
        onChangePageCHIRP: onChangePageCHIRP,
        pageIndex: pageIndex,
        pageNumber: pageIndex + 1,
        totalPages: pdf.numPages,
        children: /*#__PURE__*/_jsx(Flex, {
          "data-test-id": "pdf-viewer",
          padding: "500",
          flex: "1",
          overflow: "auto",
          position: "relative",
          children: /*#__PURE__*/_jsx(PDFPage, {
            pdf: pdf,
            pageIndex: pageIndex,
            zoom: zoom
          })
        })
      });
    };
    this.renderPDFControls = () => {
      const {
        branding,
        pageIndex,
        zoom,
        onPage,
        onZoom,
        onChangePageCHIRP
      } = this.props;
      const {
        pdf,
        hovered
      } = this.state;
      return /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        position: "absolute",
        insetBlockEnd: branding.showSalesAd ? '1500' : '1000',
        insetInlineStart: "0",
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(PDFControls, {
          visible: hovered,
          pageIndex: pageIndex,
          pageNumber: pageIndex + 1,
          totalPages: pdf.numPages,
          zoom: zoom,
          onPage: onPage,
          onChangePageCHIRP: onChangePageCHIRP,
          onZoom: onZoom
        })
      });
    };
  }
  componentDidMount() {
    this.props.onReset();
    this.loadPDFJS().then(() => {
      this.loadFile();
    }).catch(err => console.error(err));
  }
  render() {
    const {
      error,
      pdf,
      PDFJSError
    } = this.state;
    const {
      pageIndex,
      presentationName
    } = this.props;
    if (error !== null || PDFJSError !== null) {
      return /*#__PURE__*/_jsx(PDFError, {
        onRetry: this.retry,
        isPDFError: !!PDFJSError
      });
    }
    if (pdf === null) {
      return this.renderProgress();
    }
    return /*#__PURE__*/_jsxs(Flex, {
      "aria-label": I18n.text('a11y.viewSpecificPage', {
        pageNumber: pageIndex + 1,
        documentName: presentationName
      }),
      tabIndex: 0,
      flex: 1,
      position: "relative",
      overflow: "hidden",
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      children: [this.renderPDFKeyControls(), this.renderPDFControls()]
    });
  }
}
PDFViewer.defaultProps = {
  imagePlaceholders: []
};
export default connect(({
  view: {
    pdf
  }
}) => pdf, {
  onPage: PDFActions.changePage,
  onChangePageCHIRP: PDFActions.changePageCHIRP,
  onZoom: PDFActions.changeZoom,
  onReset: PDFActions.reset
})(PDFViewer);